//util.js - misc utility functions

//Utility function for getting URL parameters
//http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values
//jQuery should probably do this for us...
window.getParameterByName = function (name) {
    var match = RegExp('[?&]' + name + '=([^&]*)')
                    .exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}